<template>
    <svg class="icon-burger stroke-current" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 23">
        <line y1="1" x2="32" y2="1" fill="none" stroke-width="2"/>
        <line y1="12" x2="32" y2="12" fill="none" stroke-width="2"/>
        <line y1="22" x2="32" y2="22" fill="none" stroke-width="2"/>
    </svg>
</template>